import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PagesTitle from '../../widgets/pages_title/pages_title'
import './project_screen.css'
import AddIcon from '@mui/icons-material/Add';
import { changeGridView, deleteProjectByID, editProjectByID, selectProject, setProjectData } from '../../redux/project/projects'
import AppBarWidget from '../../widgets/app_bar/app_bar';
import { useState } from 'react';
import LoginInputWidget from '../../widgets/input/login_input'
import { useEffect } from 'react';
import { GetProjectData, changeProjectNameAPI, deleteProjectAPI } from '../../api/project';
import ResponseHttp from '../../widgets/response_http/response_http';
import { requestState } from '../../global/http_enum';
import { cookiesGlobal } from '../../App';
import { HideProgressAlert, showProgressAlert } from '../../functions/show_progress_page';
import { hundleRequestFailure } from '../../functions/hundle_request_failure';
import GridProject from './grid-view/grid_project';
import ListProject from './list-view/list_project';
import CreateProjectDialog from '../event_screen/create_project_dialog/create_project_dialog';
export default function ProjectScreen() {
  const projectState = useSelector(state => state.projectSlice);
  const dispatch = useDispatch();
  const [showCreateProject, SetShowCreateProject] = useState(false);
  const [isWizardShown, setIsWizardShown] = useState(false);
  const [editProject, SetEditProject] = useState(-1);
  const [projectNewName, SetProjectNewName] = useState("");
  const hundleCloseAlert = () => {
    SetShowCreateProject(false);
  }
  const hundleCloseEditAlert = () => {
    SetProjectNewName('');
    SetEditProject(-1);
  }
  useEffect(() => {
    if (projectState.requestState !== requestState.haveData) {
      const token = cookiesGlobal.get('auth');
      GetProjectData(token).then((e) => {
        dispatch(setProjectData(e));
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleCreateProjectComplete = () => {
    hundleCloseAlert();
    setIsWizardShown(false);
  }

  const renameProject = async () => {
    showProgressAlert();
    const response = await changeProjectNameAPI(editProject, projectNewName);
    HideProgressAlert();
    if (response.statusCode < 300) {
      dispatch(editProjectByID({ id: editProject, projectName: projectNewName }));
      hundleCloseEditAlert();
    } else {
      hundleRequestFailure(response);
    }
  }
  return (
    <>
      {!isWizardShown && (
        <>
          <AppBarWidget />
          <div id="project-screen-top">
            <PagesTitle title={'Projects'} />
            <div id="project-buttons">
              <div onClick={() => SetShowCreateProject(true)} className="create-project">
                <div className="create-project-icon-wrapper-top">
                  <AddIcon className="create-project-icon-top" />
                </div>
                <div className="create-project-text-top">Create Project</div>
              </div>
              <div className="grid-view-holder">
                Grid View
                <input onChange={() => dispatch(changeGridView())} defaultChecked={projectState.gridview} value={projectState.gridview} className='grid-view' type="checkbox" />
              </div>
            </div>
          </div>
          <div id='project-screen'>
            <ProjectViewWidget SetEditProject={SetEditProject} SetShowCreateProject={SetShowCreateProject} gridView={projectState.gridview} httpResponse={projectState.requestState} selectedProject={projectState.projectSelected} projects={projectState.project} />
          </div>
          {
            editProject !== -1 ? <div onClick={(e) => { if (e.target.id === 'show-create-project') { hundleCloseEditAlert() } }} id="show-create-project">
              <div className="content">
                <h1>Enter The New Project Name</h1>
                <LoginInputWidget height={'50px'} maxLength={50} placeholder={'New Project Name'} setValue={SetProjectNewName} type={'text'} value={projectNewName} />
                <div className="buttons">
                  <div onClick={() => hundleCloseEditAlert()} className="button red">Cancel</div>
                  <div onClick={() => renameProject()} className="button">Rename</div>
                </div>
              </div>
            </div> : <></>
          }
        </>
      )}
      {
        showCreateProject ? (
          <CreateProjectDialog 
            onClose={handleCreateProjectComplete} 
            onWizardStateChange={setIsWizardShown}
          />
        ) : <></>
      }
    </>

  )
}
const ProjectViewWidget = ({ httpResponse, selectedProject, gridView, projects, SetShowCreateProject, SetEditProject }) => {
  const dispatch = useDispatch();
  const hundleSelectProject = (project) => {
    dispatch(selectProject(project));
  }
  const [picked, SetPicked] = useState(-1);
  const deleteProject = async (id) => {
    showProgressAlert();
    const response = await deleteProjectAPI(id);
    HideProgressAlert();
    if (response.statusCode < 300) {
      // Clean up localStorage data for this project
      try {
        const storageKey = `eventProblems_${id}`;
        localStorage.removeItem(storageKey);
      } catch (error) {
        console.error('Failed to clean up localStorage for project:', error);
      }
      dispatch(deleteProjectByID(id));
    } else {
      hundleRequestFailure(response);
    }
  }
  if (requestState.haveData === httpResponse) {
    var Selected = selectedProject === null ? '' : selectedProject.id;
    if (gridView) {
      return <div className={`main-projects ${gridView ? 'main-projects-grid ' : 'main-projects-list'}`}>
        {projects.map((e, index) => <GridProject deleteProject={SetPicked} SetEditProject={SetEditProject} Selected={Selected} key={index} projectData={e} hundleSelectProject={hundleSelectProject} />)}
        <div onClick={() => SetShowCreateProject(true)} className="create-probject-grid-view">
          <div className="create-project-icon-wrapper">
            <AddIcon className="create-project-icon" />
          </div>
          <div className="create-project-text">Create Project</div>
        </div>
        {picked === -1 ? <></> : <div onClick={() => SetPicked(-1)} id="delete-item">
          <div className="alert-mesg">
            <h1>Are you sure You want to delete This Project ?</h1>
            <div className="buttons">
              <div onClick={() => SetPicked(-1)} className="bt close">Close</div>
              <div onClick={() => deleteProject(picked)} className="bt done">Confirm</div>
            </div>
          </div>
        </div>}
      </div>
    } else {
      return <div className={`main-projects ${gridView ? 'main-projects-grid ' : 'main-projects-list'}`}>
        {projects.map((e, index) => <ListProject deleteProject={SetPicked} SetEditProject={SetEditProject} Selected={Selected} key={index} projectData={e} hundleSelectProject={hundleSelectProject} />)}
        {picked === -1 ? <></> : <div onClick={() => SetPicked(-1)} id="delete-item">
          <div className="alert-mesg">
            <h1>Are you sure You want to delete This Project ?</h1>
            <div className="buttons">
              <div onClick={() => SetPicked(-1)} className="bt close">Close</div>
              <div onClick={() => deleteProject(picked)} className="bt done">Confirm</div>
            </div>
          </div>
        </div>}
      </div>
    }
  } else {
    return <ResponseHttp response={httpResponse} />
  }
}



